module.exports = __webpack_public_path__ + "img/unionpay.c82c8e07.png";